<template>
  <div class="schemes">
    <div class="schemes__table-wrapper">
      <custom-table
        :title="title"
        :tableData="dataArray"
        :pagesCount="pagesCount"
        :paginationMethod="'fetchSchemes'"
        class="schemes__table"
        :extLoading="loading"
      >
        <template slot="headerData">
          <div class="table__flex-header">
            <div class="table__title">{{ title }}</div>
          </div>
        </template>
        <template slot="thead">
          <th>Id</th>
          <th>Name</th>
          <th>Created</th>
          <th>Updated</th>
        </template>
        <template slot-scope="{ row }">
          <td>{{ row.id }}</td>
          <td>{{ row.name }}</td>
          <td>{{ convertData(row.created_at) }}</td>
          <td>{{ convertData(row.updated_at) }}</td>
          <td>
            <div class="schemes__options-col">
              <p-button
                size="sm"
                type="default"
                style="margin-right:10px"
                @click.native="getSchemeDetails(row.id)"
                >Details</p-button
              >
              <drop-down tag="div" title="Options">
                <a class="dropdown-item" @click="modalToggle(row.id)">Delete</a>
              </drop-down>
            </div>
          </td>
        </template>
      </custom-table>
    </div>

    <new-scheme :loading="loadingScheme" class="schemes__form" />
  </div>
</template>

<script>
import { apiError } from "@/util/ErrorMessage.js";
import CustomTable from "../../customReusableComponents/CustomTable";
import NewScheme from "./NewScheme/NewSheme";

export default {
  components: { CustomTable, NewScheme },
  data() {
    return {
      title: "SCHEMES",
      loading: false,
      loadingScheme: false
    };
  },
  computed: {
    pagesCount() {
      const entries = this.$store.getters.getSchemesQuantity;
      return Math.ceil(entries / 5);
    },
    dataArray() {
      const entries = this.$store.getters.schemes;
      return entries;
    }
  },
  methods: {
    convertData(data) {
      return new Date(data)
        .toDateString()
        .split(" ")
        .slice(1, 4)
        .join(" ");
    },
    modalToggle(id) {
      this.$store.dispatch("toggleModal");
      this.$store.dispatch("sendShemeIdToModal", id);
    },
    async getSchemeDetails(id) {
      this.loadingScheme = true;

      try {
        await this.$store.dispatch("getSchemeById", id);
      } catch (error) {
        apiError(error);
      }

      this.loadingScheme = false;
    }
  },
  async created() {
    this.loading = true;

    try {
      await this.$store.dispatch("fetchSchemes", 1);
    } catch (error) {
      apiError(error);
    }

    this.loading = false;
  }
};
</script>
<style lang="scss" scoped>
.schemes {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  &__table-wrapper {
    width: 60%;
    overflow: auto;
    margin-bottom: 20px;

    @media only screen and (min-width: 320px) and (max-width: 900px) {
      width: 100%;
    }
  }

  &__table {
    width: 100%;

    @media only screen and (min-width: 320px) and (max-width: 600px) {
      width: 600px;
    }
  }

  &__options-col {
    display: flex;
    align-items: center;
  }

  &__form {
    width: 35%;
    margin: 0 auto;

    @media only screen and (min-width: 481px) and (max-width: 900px) {
      width: 60%;
    }
    @media only screen and (min-width: 320px) and (max-width: 480px) {
      width: 100%;
    }
  }
}
</style>
